<template>
  <a-modal :visible="visible" title="申请退款" :confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel" destroyOnClose>
    <a-form ref="formRef" :model="formState" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
      <a-form-item label="订单编号">
        <span style="font-weight: bold;">{{ detail.orderNo }}</span>
      </a-form-item>

      <a-form-item label="退款金额">
        <span style="color: #ff4d4f; font-weight: bold; font-size: 16px;">￥{{ detail.payAmount }}</span>
      </a-form-item>

      <a-form-item label="退款原因" name="reason" :rules="[{ required: true, message: '请输入退款原因' }]">
        <a-textarea v-model:value="formState.reason" placeholder="请输入详细的退款说明" :rows="4" :maxlength="200" show-count />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { ExecuteOperation } from '@/api/order';

export default {
  name: 'RefundModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      confirmLoading: false,
      formState: {
        reason: ''
      }
    };
  },
  computed: {
    // 自动计算金额（单位：分）
    refundTotalFen() {
      const amount = Number(this.detail.payAmount) || 0;
      return Math.round(amount * 100);
    }
  },
  methods: {
    async handleOk() {
      try {
        await this.$refs.formRef.validate();
        this.confirmLoading = true;

        const params = {
          uuid: this.detail.uuid,           // 订单ID
          operation: '发起退款',         // 指定操作类型
          refundTotal: this.refundTotalFen, // 金额（分）
          refundReason: this.formState.reason // 原因
        };

        const res = await ExecuteOperation(params);

        if (res.errCode === 0) {
          this.$message.success('退款申请提交成功');
          this.$emit('refresh');           // 刷新列表/详情
          this.$emit('update:visible', false); // 关闭弹窗
        } else {
          this.$message.error(res.message || '操作失败');
        }
      } catch (error) {
        if (!error.errorFields) { // 排除表单校验错误
          this.$message.error('网络异常，请稍后重试');
        }
      } finally {
        this.confirmLoading = false;
      }
    },
    handleCancel() {
      this.$emit('update:visible', false);
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.formState.reason = ''; // 重置表单
      }
    }
  }
};
</script>